import { useFormik } from 'formik';
import React, { useContext, useEffect, useRef, useState } from 'react';
import * as Yup from "yup";
import { Container } from '../../base/Container';
import AppToaster from '../../commonLib/AppToaster';
import { TextBoxTranslater } from '../../commonLib/TextBoxTranslater';
import { getCanvas } from "react-lasso-select";
import mergeImages from 'merge-images';
import rotate from 'base64-rotate'
import { FileUploader } from '../../commonLib/FileUploader';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { organizationContext } from '../Organization/organizationContext';
import { PrintStarterDash } from '../Prints/PrintStaterDash';
import { DrapingPrint } from '../Prints/DrapingPrint';
import { DrapingView } from './DrapingView';
import *as sareeDrapingCrud from './../../_crud/sareeDrapingCrud'
import { DrapingBalance } from './DrapingBalance';
import * as organizationCrud from './../../_crud/organizationCrud'
import { getIsPrint } from '../../config/GlobalSettings';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { loadingMiniContext } from '../../commonLib/lodingMiniContext';

export function Pose1() {
    const [organization, setOrganization] = useContext(organizationContext);
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)

    const Schema = Yup.object().shape({
        itemName: Yup.string().min(3, "Item Name must between 3 to 50 characters").max(50, "Item Name must between 3 to 50 characters").required("Item Name is required."),
        itemCode: Yup.string().min(1, "Item Code must between 1 to 15 characters").max(15, "Item Code must between 1 to 15 characters").required("Item Code is required."),
    })

    const initialValues = {
        itemName: "",
        itemCode: "",
        note: "",
        isModelBlur: 0,
        isReal: 0,
        isLace: 0,
        isLight: 0,
    }

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values) => {
            DrapNow()
        },
        onReset: (values, { resetForm }) => {
            resetForm();
        },
    });

    /////////////Draping////////////
    const [localLoading, setLocalLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [isDraped, setIsDraped] = useState(false);
    const [isDrapedFrontCompleted, setIsDrapedFrontCompleted] = useState(false);
    const [isDrapedBackCompleted, setIsDrapedBackCompleted] = useState(false);
    const [FinalDraper, setFinalDraper] = useState("");
    const [FinalDraperBack, setFinalDraperBack] = useState("");
    const [FinalDraperNoModel, setFinalDraperNoModel] = useState("");
    const [FinalDraperFold, setFinalDraperFold] = useState("");
    const [FinalDraperMulti, setFinalDraperMulti] = useState("");
    const [FinalDraperSide, setFinalDraperSide] = useState("");

    const width = 500;

    const MergeSaree = () => {
        mergeImages([
            { src: ((!img4 || img4 == "./assets/images/Draper/4.png") ? './assets/images/Draper/5.png' : img4), x: 700, y: 80 },
            { src: saree3, x: 210, y: 794 },
            { src: saree5, x: 474, y: 482 },
            { src: saree4, x: 295, y: 494 },
            { src: saree2, x: 165, y: 855 },
            { src: saree1, x: 110, y: 860 },
            { src: saree9, x: 135, y: 288 },
            { src: saree8, x: 188, y: 284 },
            { src: saree7, x: 169, y: 549 },
            { src: (formik.values.isReal == 0 ? (formik.values.isLight == 0 ? './assets/images/Draper/DrapShadowX.png' : './assets/images/Draper/DrapShadowLight.png') : './assets/images/Draper/DrapShadow.png'), x: 0, y: 0 },
            { src: (formik.values.isModelBlur == 0 ? './assets/images/Draper/ModelImg.png' : './assets/images/Draper/ModelImgBlur.png'), x: 0, y: 0 },
            { src: (formik.values.isLace == 0 ? './assets/images/Draper/5.png' : './assets/images/Draper/LaceFront.png'), x: 0, y: 1298 },
        ])
            .then(b64 => {
                setFinalDraper(b64)
                setIsDrapedFrontCompleted(true)
            });
    }
    const MergeSareeBack = () => {
        mergeImages([
            { src: sareeBack5, x: 607, y: 265 },
            { src: sareeBack3, x: 545, y: 457 },
            { src: (formik.values.isModelBlur == 0 ? './assets/images/Draper/ModelImgBack.png' : './assets/images/Draper/ModelImgBackBlur.png'), x: 0, y: 0 },
            { src: sareeBack4, x: 514, y: 250 },
            { src: sareeBack2, x: 348, y: 252 },
            { src: sareeBack1, x: 57, y: 490 },
            { src: './assets/images/Draper/Draping BackHand.png', x: 0, y: 0 },
            { src: (formik.values.isReal == 0 ? './assets/images/Draper/DrapShadowBackX.png' : './assets/images/Draper/DrapShadowBack.png'), x: 0, y: 0 },
            { src: (formik.values.isLace == 0 ? './assets/images/Draper/5.png' : './assets/images/Draper/LaceBack.png'), x: 0, y: 1215 },
        ])
            .then(b64 => {
                setFinalDraperBack(b64)
            });
    }
    const MergeSareeNoModel = () => {
        mergeImages([
            { src: sareeNoMOdel8, x: 545, y: 349 },
            { src: sareeNoMOdel7, x: 517, y: 331 },
            { src: sareeNoMOdel6, x: 490, y: 405 },
            { src: sareeNoMOdel4, x: 435, y: 613 },
            { src: sareeNoMOdel5, x: 417, y: 459 },
            { src: sareeNoMOdel3, x: 405, y: 629 },
            { src: sareeNoMOdel2, x: 377, y: 662 },
            { src: (formik.values.isLace == 0 ? './assets/images/Draper/5.png' : './assets/images/Draper/LaceNoModel.png'), x: 480, y: 738 },
            { src: sareeNoMOdel1, x: 310, y: 685 },
            { src: sareeNoMOdel10, x: 274, y: 246 },
            { src: sareeNoMOdel11, x: 406, y: 563 },
            { src: sareeNoMOdel9, x: 276, y: 254 },
            { src: './assets/images/Draper/DrapNoModelShadow.png', x: 0, y: 0 },
        ])
            .then(b64 => {
                setFinalDraperNoModel(b64)
            });
    }
    const MergeSareeFold = () => {
        mergeImages([
            { src: sareeFold1, x: 0, y: 0 },
            { src: sareeFold8, x: 0, y: 0 },
            { src: sareeFold7, x: 0, y: 0 },
            { src: sareeFold6, x: 0, y: 0 },
            { src: sareeFold5, x: 0, y: 0 },
            { src: sareeFold4, x: 0, y: 0 },
            { src: sareeFold3, x: 0, y: 0 },
            { src: sareeFold2, x: 0, y: 0 },
            { src: './assets/images/Draper/DrapingFold.png', x: 0, y: 0 },
        ])
            .then(b64 => {
                resizeImage(b64, 603, 900).then(samll2 => {
                    setFinalDraperFold(samll2)
                }).catch(err => {
                })
            });
    }
    const MergeSareeSide = () => {
        mergeImages([
            { src: sareeSide3, x: 350, y: 779 },
            { src: sareeSide9, x: 360, y: 317 },
            { src: sareeSide2, x: 308, y: 817 },
            { src: sareeSide1, x: 284, y: 855 },
            { src: sareeSide4, x: 325, y: 572 },
            { src: sareeSide5, x: 350, y: 289 },
            { src: sareeSide8, x: 590, y: 335 },
            { src: sareeSide7, x: 585, y: 895 },
            { src: sareeSide6, x: 431, y: 522 },
            { src: (formik.values.isLace == 0 ? './assets/images/Draper/5.png' : './assets/images/Draper/LaceSide.png'), x: 447, y: 1088 },
            { src: './assets/images/Draper/DrapShadowSide.png', x: 0, y: 0 },
            { src: (formik.values.isModelBlur == 0 ? './assets/images/Draper/DrapingSideHead.png' : './assets/images/Draper/DrapingSideHeadBlur.png'), x: 0, y: 0 },
        ])
            .then(b64 => {
                setFinalDraperSide(b64)
            });
    }
    const MergeSareeMulti = () => {
        mergeImages([
            { src: FinalDraperBack, x: 0, y: 0 },
            { src: FinalDraperNoModel, x: 750, y: 1200 },
            { src: FinalDraperFold, x: 200, y: 1550 },
            { src: FinalDraperSide, x: 800, y: 0 },
            { src: './assets/images/Draper/MultiBack.png', x: 0, y: 0 },
        ])
            .then(b64 => {
                setFinalDraperMulti(b64)
                setIsDrapedBackCompleted(true)
            });
    }

    const [img1, setImg1] = useState("");
    const [img2, setImg2] = useState("");
    const [img3, setImg3] = useState("");
    const [img4, setImg4] = useState("");

    //////////////Model Front////////////////////////
    const [saree1, setSaree1] = useState("");
    const GetSaree1 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "364,695 324,700 306,695 308,652 312,623 322,564 328,514 342,441 354,388 365,331 383,247 384,214 407,198"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSaree1(canvas.toDataURL());
            }
        });
    }
    const [saree2, setSaree2] = useState("");
    const GetSaree2 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "426,694 425,664 433,537 461,213 473,187 491,698 449,700"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSaree2(canvas.toDataURL());
            }
        });
    }
    const [saree3, setSaree3] = useState("");
    const GetSaree3 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "550,699 538,202 548,185 571,167 623,130 644,686 598,696"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSaree3(canvas.toDataURL());
            }
        });
    }
    const [saree4, setSaree4] = useState("");
    const GetSaree4 = () => {
        setLocalLoading(true)
        let sareeSrc = img2
        let initPP = "1,357 1,1181 3,1198 36,1201 258,1195 364,1189 408,1177 419,1167 386,1147 348,1125 329,1095 306,1041 291,974 260,794 238,635 224,503 209,330 195,274 181,260 148,264 1,311"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSaree4(canvas.toDataURL());
            }
        });
    }
    const [saree5, setSaree5] = useState("");
    const GetSaree5 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrc => {
            rotate(newsrc, 158).then(newsrc2 => {
                let initPP = "738,1258 693,1238 660,1192 637,1130 603,967 594,896 558,652 539,487 536,443 526,379 512,350 549,336 555,359 555,371 550,380 561,409 697,707 769,854 901,1109 927,1149 941,1165 933,1177 908,1192 890,1192 879,1206 845,1218 812,1234 785,1253 762,1258"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(newsrc2, initPP, (err, canvas) => {
                    if (!err) {
                        setSaree5(canvas.toDataURL());
                    }
                });

            }).catch(err => {
            })
        }).catch(err => {
        })
    }
    const [saree6, setSaree6] = useState("");
    const GetSaree6 = () => {
        setLocalLoading(true)
        let sareeSrc = img2
        let initPP = "355,1173 310,1147 279,1106 252,1047 218,884 209,814 173,570 154,404 151,360 141,295 127,266 164,253 169,274 169,287 166,297 176,327 312,624 383,771 516,1026 542,1065 555,1082 548,1093 522,1110 505,1110 493,1122 460,1135 426,1150 400,1169 379,1180"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSaree6(canvas.toDataURL());
            }
        });
    }
    const [saree7, setSaree7] = useState("");
    const GetSaree7 = () => {
        setLocalLoading(true)
        rotate(img2, 139).then(newsrc => {
            let sareeSrc = newsrc
            let initPP = "1141,709 1110,681 1074,634 1051,605 848,604 806,605 815,708 832,709 853,717 884,725 919,730 955,730 993,726 1044,719 1086,714 1120,712"
                .split(" ")
                .map((c) => c.split(",").map(Number))
                .map(([x, y]) => ({ x, y }));

            getCanvas(sareeSrc, initPP, (err, canvas) => {
                if (!err) {
                    rotate(canvas.toDataURL(), 90).then(newsrc1 => {
                        setSaree7(newsrc1);
                    }).catch(err => {
                    })
                }
            });
        }).catch(err => {
        })

    }
    const [saree8, setSaree8] = useState("");
    const GetSaree8 = () => {
        setLocalLoading(true)
        rotate(img2, 72).then(newsrc => {
            let sareeSrc = newsrc
            let initPP = "768,608 810,602 832,602 855,597 864,582 879,566 892,566 905,566 919,562 936,563 953,556 972,551 1088,534 1073,594 1067,632 1064,655 1071,673 1079,685 1080,701 1082,720 1073,743 1061,758 1033,769 1012,775 980,785 965,791 930,803 893,814 862,823 849,814 839,802 826,796 817,777 809,757 801,737 794,700 782,669 773,646 769,625"
                .split(" ")
                .map((c) => c.split(",").map(Number))
                .map(([x, y]) => ({ x, y }));

            getCanvas(sareeSrc, initPP, (err, canvas) => {
                if (!err) {
                    rotate(canvas.toDataURL(), 179).then(newsrc1 => {
                        setSaree8(newsrc1);
                    }).catch(err => {
                    })
                }
            });
        }).catch(err => {
        })

    }
    const [saree9, setSaree9] = useState("");
    const GetSaree9 = () => {
        setLocalLoading(true)
        rotate(img3, 30).then(newsrc => {
            let sareeSrc = newsrc
            let initPP = "170,609 179,619 192,626 209,634 243,575 235,556 235,538 238,523 291,519 355,495 416,460 453,437 429,432 381,454 355,465 306,481 288,481 276,476 279,462 281,444 292,432 265,442 238,452 227,458 219,470 209,499"
                .split(" ")
                .map((c) => c.split(",").map(Number))
                .map(([x, y]) => ({ x, y }));

            getCanvas(sareeSrc, initPP, (err, canvas) => {
                if (!err) {
                    rotate(canvas.toDataURL(), 0).then(newsrc => {
                        setSaree9(newsrc);
                    }).catch(err => {
                    })
                }
            });
        }).catch(err => {
        })

    }


    ////////////////BACK IMAGE////////////////////////////////////
    const [sareeBack3, setSareeBack3] = useState("");
    const GetSareeBack3 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "395,332 464,329 518,550"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeBack3(canvas.toDataURL());
            }
        });
    }
    const [sareeBack4, setSareeBack4] = useState("");
    const GetSareeBack4 = () => {
        setLocalLoading(true)
        let sareeSrc = img3
        let initPP = "129,499 146,491 156,471 166,450 177,423 181,403 189,380 206,387 226,389 253,398 251,413 246,440 235,485 224,533 223,555 230,598 162,598"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeBack4(canvas.toDataURL());
            }
        });
    }
    const [sareeBack5, setSareeBack5] = useState("");
    const GetSareeBack5 = () => {
        setLocalLoading(true)
        rotate(img3, 179).then(newsrc => {
            rotate(newsrc, 176).then(newsrc2 => {
                let initPP = "188,490 181,464 175,435 175,396 175,356 185,319 191,302 199,287 219,299 236,335 251,397 262,466 272,546 283,631 225,633 219,607 204,543"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(newsrc2, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeBack5(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })
    }
    const [sareeBack1, setSareeBack1] = useState("");
    const GetSareeBack1 = () => {
        setLocalLoading(true)
        rotate(img2, 6).then(newsrc => {
            let sareeSrc = newsrc
            let initPP = "7,1167 102,221 121,207 154,211 171,218 213,218 226,218 243,218 262,223 289,218 302,211 444,1133 440,1149 403,1154 282,1154 169,1154 59,1165"
                .split(" ")
                .map((c) => c.split(",").map(Number))
                .map(([x, y]) => ({ x, y }));

            getCanvas(sareeSrc, initPP, (err, canvas) => {
                if (!err) {
                    setSareeBack1(canvas.toDataURL())
                }
            });
        }).catch(err => {
        })

    }
    const [sareeBack2, setSareeBack2] = useState("");
    const GetSareeBack2 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 155).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "633,37 1122,1014 1125,1027 1074,1051 968,1112 912,1159 890,1173 814,1198 670,1217 626,1220 523,286 528,269 528,227 526,144 533,122 548,103 560,88 594,68 619,51"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeBack2(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }


    //////////////No MOdel/////////////////////////////
    const [sareeNoMOdel1, setSareeNoModel1] = useState("");
    const GetsareeNoMOdel1 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "71,700 52,696 40,694 52,588 61,479 55,365 40,261 134,67 116,677 116,694 102,700"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeNoModel1(canvas.toDataURL());
            }
        });
    }
    const [sareeNoMOdel2, setSareeNoModel2] = useState("");
    const GetsareeNoMOdel2 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "69,697 48,692 57,340 69,73 87,43 87,257 88,613 90,694"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeNoModel2(canvas.toDataURL());
            }
        });
    }
    const [sareeNoMOdel3, setSareeNoModel3] = useState("");
    const GetsareeNoMOdel3 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "74,699 58,699 66,60 90,16 94,426 98,511 111,647 113,697 87,700"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeNoModel3(canvas.toDataURL());
            }
        });
    }
    const [sareeNoMOdel4, setSareeNoModel4] = useState("");
    const GetsareeNoMOdel4 = () => {
        setLocalLoading(true)
        rotate(img1, 179).then(newsrcX => {
            rotate(newsrcX, 175).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "243,804 232,498 232,141 257,106 261,295 270,491 270,552 279,645 291,739 298,788 298,797 273,800 259,804"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeNoModel4(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeNoMOdel5, setSareeNoModel5] = useState("");
    const GetsareeNoMOdel5 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "331,501 326,520 314,398 307,194 271,192 310,117 360,0 367,60 379,120 389,137 394,170 391,201 386,233 382,292 374,340 360,408 353,443"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeNoModel5(canvas.toDataURL());
            }
        });
    }
    const [sareeNoMOdel6, setSareeNoModel6] = useState("");
    const GetsareeNoMOdel6 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 175).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "344,1235 330,1228 351,1133 368,974 360,893 340,821 348,794 373,742 414,967 465,1218 409,1230"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeNoModel6(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeNoMOdel7, setSareeNoModel7] = useState("");
    const GetsareeNoMOdel7 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 165).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "638,1254 531,735 549,703 642,989 718,1214 690,1232 662,1244"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeNoModel7(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeNoMOdel8, setSareeNoModel8] = useState("");
    const GetsareeNoMOdel8 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 151).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "1085,1106 975,812 931,647 952,610 1069,814 1188,1014 1146,1054"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeNoModel8(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeNoMOdel9, setSareeNoModel9] = useState("");
    const GetsareeNoMOdel9 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 26).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "650,1391 916,827 924,811 921,797 869,773 827,754 801,804 799,813 773,860 721,938 693,983 676,1002 662,1018 648,1040 638,1058 620,1080 615,1115 615,1188 629,1271"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeNoModel9(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeNoMOdel10, setSareeNoModel10] = useState("");
    const GetsareeNoMOdel10 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 65).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "153,731 166,675 185,603 187,564 181,527 177,501 174,484 174,468 178,454 191,445 246,417 318,383 331,383 355,386 373,394 303,558 154,750"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeNoModel10(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeNoMOdel11, setSareeNoModel11] = useState("");
    const GetsareeNoMOdel11 = () => {
        setLocalLoading(true)
        let sareeSrc = img1
        let initPP = "178,360 175,412 199,403 214,398 228,398 240,388 235,252 185,336"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeNoModel11(canvas.toDataURL());
            }
        });
    }

    //////////////Fold/////////////////////////////
    const [sareeFold1, setSareeFold1] = useState("");
    const GetsareeFold1 = () => {
        setLocalLoading(true)
        let sareeSrc = img3
        let initPP = "77,0 479,0 479,600 77,600"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeFold1(canvas.toDataURL());
            }
        });
    }
    const [sareeFold2, setSareeFold2] = useState("");
    const GetsareeFold2 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 87).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "151,775 178,773 196,772 203,765 202,735 193,654 168,319 161,254 86,254 84,777 111,777"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold2(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeFold3, setSareeFold3] = useState("");
    const GetsareeFold3 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 84).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "371,805 252,820 251,305 348,305 387,655 407,791 406,797 396,804"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold3(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeFold4, setSareeFold4] = useState("");
    const GetsareeFold4 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 83).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "435,809 369,821 269,835 269,343 380,343 400,476 438,676 454,772 458,788 456,794 451,804"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold4(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeFold5, setSareeFold5] = useState("");
    const GetsareeFold5 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 82).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "553,815 529,821 345,855 345,373 468,373 519,596 569,786 570,797 569,812"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold5(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeFold6, setSareeFold6] = useState("");
    const GetsareeFold6 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 76).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "585,880 528,894 355,940 355,464 495,463 562,675 622,860 620,864 618,867"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold6(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeFold7, setSareeFold7] = useState("");
    const GetsareeFold7 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 71).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "982,803 927,824 778,872 778,403 929,403 1012,598 1079,750 1081,764 1050,778"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold7(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeFold8, setSareeFold8] = useState("");
    const GetsareeFold8 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 60).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "1266,641 1275,657 1276,662 1276,672 1237,699 1186,717 939,762 939,359 1111,359"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeFold8(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }

    //////////SIDE/////////////////////////////
    const [sareeSide1, setSareeSide1] = useState("");
    const GetsareeSide1 = () => {
        setLocalLoading(true)
        rotate(img1, 8).then(newsrcX => {
            let sareeSrc = newsrcX
            let initPP = "138,712 120,703 125,646 131,610 131,551 132,484 138,325 148,266 152,240 157,221 162,186 165,166 186,153 177,200 165,285 157,442 161,587 159,688 159,715"
                .split(" ")
                .map((c) => c.split(",").map(Number))
                .map(([x, y]) => ({ x, y }));

            getCanvas(sareeSrc, initPP, (err, canvas) => {
                if (!err) {
                    setSareeSide1(canvas.toDataURL());
                }
            })
        }).catch(err => {
        })

    }
    const [sareeSide2, setSareeSide2] = useState("");
    const GetsareeSide2 = () => {
        setLocalLoading(true)
        rotate(img1, 8).then(newsrcX => {
            let sareeSrc = newsrcX
            let initPP = "85,702 95,439 100,271 123,162 125,149 184,109 168,167 156,337 150,680 153,711 134,712 118,707 105,707"
                .split(" ")
                .map((c) => c.split(",").map(Number))
                .map(([x, y]) => ({ x, y }));

            getCanvas(sareeSrc, initPP, (err, canvas) => {
                if (!err) {
                    setSareeSide2(canvas.toDataURL());
                }
            })
        }).catch(err => {
        })

    }
    const [sareeSide3, setSareeSide3] = useState("");
    const GetsareeSide3 = () => {
        setLocalLoading(true)
        rotate(img1, 179).then(newsrcX => {
            rotate(newsrcX, 156).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "523,1041 516,926 510,605 543,453 554,426 600,396 604,435 604,461 607,490 608,530 611,544 611,569 617,614 622,675 627,745 622,811 617,861 621,908 617,941 621,957 622,994 571,1020 558,1024 550,1035"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeSide3(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeSide4, setSareeSide4] = useState("");
    const GetsareeSide4 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 53).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "625,1153 738,1063 736,978 736,894 737,871 710,856 679,845 665,846 651,934 643,982 637,1043 626,1139"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeSide4(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeSide5, setSareeSide5] = useState("");
    const GetsareeSide5 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 53).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "296,709 266,710 262,682 262,648 262,616 259,597 256,569 261,556 293,529 322,508 401,447 433,430 476,419 502,419 524,436 534,447 546,473 563,510 570,536 544,634 517,686 396,706"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeSide5(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeSide6, setSareeSide6] = useState("");
    const GetsareeSide6 = () => {
        setLocalLoading(true)
        rotate(img2, 179).then(newsrcX => {
            rotate(newsrcX, 179).then(newsrc => {
                let sareeSrc = newsrc
                let initPP = "31,388 24,421 16,446 44,1176 46,1222 74,1221 157,1213 193,1212 197,1169 210,1040 218,875 222,750 228,689 213,548 207,440 190,360 172,358 160,347 148,348 135,361 99,382 61,393"
                    .split(" ")
                    .map((c) => c.split(",").map(Number))
                    .map(([x, y]) => ({ x, y }));

                getCanvas(sareeSrc, initPP, (err, canvas) => {
                    if (!err) {
                        setSareeSide6(canvas.toDataURL());
                    }
                });
            }).catch(err => {
            })
        }).catch(err => {
        })

    }
    const [sareeSide7, setSareeSide7] = useState("");
    const GetsareeSide7 = () => {
        setLocalLoading(true)
        let sareeSrc = img2
        let initPP = "254,1187 225,1197 271,820 335,1132 282,1178"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeSide7(canvas.toDataURL());
            }
        });
    }
    const [sareeSide8, setSareeSide8] = useState("");
    const GetsareeSide8 = () => {
        setLocalLoading(true)
        let sareeSrc = img2
        let initPP = "353,1185 376,1183 392,1172 401,1157 391,918 388,890 389,767 387,635 380,565 350,467 332,406 320,391 290,459 283,540 276,587 292,706 332,1148 329,1183"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeSide8(canvas.toDataURL());
            }
        });
    }
    const [sareeSide9, setSareeSide9] = useState("");
    const GetsareeSide9 = () => {
        setLocalLoading(true)
        let sareeSrc = img3
        let initPP = "288,275 270,277 233,328 222,373 230,409 234,391 241,373 260,354 289,331 286,301"
            .split(" ")
            .map((c) => c.split(",").map(Number))
            .map(([x, y]) => ({ x, y }));

        getCanvas(sareeSrc, initPP, (err, canvas) => {
            if (!err) {
                setSareeSide9(canvas.toDataURL());
            }
        });
    }
    ///////////////////////////////////////////

    useEffect(() => {
        if (img1 && img2 && img3) {
            GetSaree1()
            GetSaree2()
            GetSaree3()
            GetSaree4()
            GetSaree5()
            GetSaree6()
            GetSaree7()
            GetSaree8()
            GetSaree9()

            GetSareeBack1()
            GetSareeBack2()
            GetSareeBack3()
            GetSareeBack4()
            GetSareeBack5()

            GetsareeNoMOdel1()
            GetsareeNoMOdel2()
            GetsareeNoMOdel3()
            GetsareeNoMOdel4()
            GetsareeNoMOdel5()
            GetsareeNoMOdel6()
            GetsareeNoMOdel7()
            GetsareeNoMOdel8()
            GetsareeNoMOdel9()
            GetsareeNoMOdel10()
            GetsareeNoMOdel11()

            GetsareeFold1()
            GetsareeFold2()
            GetsareeFold3()
            GetsareeFold4()
            GetsareeFold5()
            GetsareeFold6()
            GetsareeFold7()
            GetsareeFold8()

            GetsareeSide1()
            GetsareeSide2()
            GetsareeSide3()
            GetsareeSide4()
            GetsareeSide5()
            GetsareeSide6()
            GetsareeSide7()
            GetsareeSide8()
            GetsareeSide9()
        }
    }, [img1, img2, img3])

    useEffect(() => {
        if (saree1 && saree2 && saree3 && saree4 && saree5
            && saree6 && saree7 && saree8 && saree9 && sareeBack1 && sareeBack2 && sareeBack3 && sareeBack4 && sareeBack5 &&
            sareeNoMOdel1 && sareeNoMOdel2 && sareeNoMOdel3 && sareeNoMOdel4 && sareeNoMOdel5 && sareeNoMOdel6 && sareeNoMOdel7 && sareeNoMOdel8 &&
            sareeNoMOdel9 && sareeNoMOdel10 && sareeNoMOdel11 && GetsareeFold1 && GetsareeFold2 && GetsareeFold3 && GetsareeFold4 &&
            GetsareeFold5 && GetsareeFold6 && GetsareeFold7 && GetsareeFold8 && GetsareeSide1 && GetsareeSide2 && GetsareeSide3 &&
            GetsareeSide4 && GetsareeSide5 && GetsareeSide6 && GetsareeSide7 && GetsareeSide8 && GetsareeSide9) {
            setLocalLoading(false)
        }
    }, [saree1, saree2, saree3, saree4, saree5,
        saree6, saree7, saree8, saree9, sareeBack1, sareeBack2, sareeBack3, sareeBack4, sareeBack5,
        sareeNoMOdel1, sareeNoMOdel2, sareeNoMOdel3, sareeNoMOdel4, sareeNoMOdel5, sareeNoMOdel6, sareeNoMOdel7, sareeNoMOdel8,
        sareeNoMOdel9, sareeNoMOdel10, sareeNoMOdel11, GetsareeFold1, GetsareeFold2, GetsareeFold3, GetsareeFold4,
        GetsareeFold5, GetsareeFold6, GetsareeFold7, GetsareeFold8, GetsareeSide1, GetsareeSide2, GetsareeSide3,
        GetsareeSide4, GetsareeSide5, GetsareeSide6, GetsareeSide7, GetsareeSide8, GetsareeSide9])

    useEffect(() => {
        if (FinalDraperBack && FinalDraperNoModel && FinalDraperFold && FinalDraperSide) {
            MergeSareeMulti()
        }
    }, [FinalDraperBack, FinalDraperNoModel, FinalDraperFold, FinalDraperSide])

    const DrapNow = () => {
        setLocalLoading(true)
        organizationCrud.GetOrganization()
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        if (hdata.drapingBalance < 1) {
                            AppToaster("Your draping balance is insufficient, please recharge and try again.", "error")
                            setLocalLoading(false)
                        }
                        else {
                            MergeSaree();
                            MergeSareeBack();
                            MergeSareeFold();
                            MergeSareeNoModel();
                            MergeSareeSide();
                            setIsDraped(true)
                        }
                    }
                    else {
                        setLocalLoading(false)
                    }
                }
                else {
                    setLocalLoading(false)
                }
            })
            .catch(error => {
                setLocalLoading(false)
            })
    }

    useEffect(() => {
        if (isDraped && isDrapedFrontCompleted && isDrapedBackCompleted) {
            DrapeSuccess()
        }
    }, [isDrapedFrontCompleted, isDrapedBackCompleted])

    function urltoFile(url, filename, mimeType) {
        return (fetch(url)
            .then(function (res) { return res.arrayBuffer(); })
            .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
        );
    }

    const resizeImage = (base64Str, width = 400, height = 350) => {
        return new Promise((resolve) => {
            let img = new Image()
            img.src = base64Str
            img.onload = () => {
                let canvas = document.createElement('canvas')
                canvas.width = width
                canvas.height = height
                let ctx = canvas.getContext('2d')
                ctx.drawImage(img, 0, 0, width, height)
                resolve(canvas.toDataURL())
            }
        })
    }

    const DrapeSuccess = () => {
        setLocalLoading(true)

        sareeDrapingCrud.DrapingSuccess()
            .then(res => {
                if (res.data.succeeded) {
                    setLocalLoading(false);
                    setIsSaved(true)
                    AppToaster('Draped successfully.', 'success')
                }
                else {
                    DrapReset()
                    AppToaster(res.data.message, 'error')
                    alert(res.data.result.message)
                }

            }).catch(error => {
                setLocalLoading(false);
                setIsDraped(false)
                alert(error)
                AppToaster(error, 'error')
            })
    }

    const DrapeUpload = () => {
        if (isDraped && isDrapedFrontCompleted && isDrapedBackCompleted) {
            setLocalLoading(true)
            urltoFile(FinalDraper, "DrapedFront.png", "image/png").then(res1 => {
                urltoFile(FinalDraperMulti, "DrapedBack.png", "image/png").then(res2 => {
                    resizeImage(FinalDraper, 200, 300).then(samll1 => {
                        resizeImage(FinalDraperMulti, 200, 335).then(samll2 => {
                            urltoFile(samll1, "DrapedFrontSamll.png", "image/png").then(resSmall1 => {
                                urltoFile(samll2, "DrapedBackSamll.png", "image/png").then(resSmall2 => {
                                    DrapeSave(res1, res2, resSmall1, resSmall2)
                                    //setIsSaved(true)
                                    //setLocalLoading(false);
                                })
                            })
                        }).catch(err => {
                        })

                    }).catch(err => {
                    })
                })
            })
        }
        else {
            AppToaster("Draping is incomplete.", 'error')
        }
    }

    const DrapeSave = (fileFront, fileBack, fileFrontSmall, fileBackSmall) => {

        setLocalLoading(true)

        const formData = new FormData()
        formData.append('itemName', formik.values.itemName)
        formData.append('itemCode', formik.values.itemCode)
        formData.append('note', formik.values.note)

        if (fileFront)
            formData.append('drapingFront', fileFront)
        if (fileBack)
            formData.append('drapingBack', fileBack)
        if (fileFrontSmall)
            formData.append('drapingFrontSmall', fileFrontSmall)
        if (fileBackSmall)
            formData.append('drapingBackSmall', fileBackSmall)

        sareeDrapingCrud.Add(formData)
            .then(res => {
                if (res.data.result.succeeded) {
                    setLocalLoading(false);
                    setIsSaved(true)
                    AppToaster('Uploaded and Added successfully.', 'success')
                }
                else {
                    DrapReset()
                    AppToaster(res.data.result.message, 'error')
                    alert(res.data.result.message)
                }

            }).catch(error => {
                setLocalLoading(false);
                setIsDraped(false)
                alert(error)
                AppToaster(error, 'error')
            })
    }

    const DrapReset = () => {
        setImg1("./assets/images/Draper/1.jpeg")
        setImg2("./assets/images/Draper/2.jpeg")
        setImg3("./assets/images/Draper/3.jpg")
        setImg4("./assets/images/Draper/4.png")

        setIsDrapedFrontCompleted(false)
        setIsDrapedBackCompleted(false)

        setIsSaved(false);
        setFinalDraper("");
        setFinalDraperBack("");
        setFinalDraperNoModel("");
        setFinalDraperFold("");
        setFinalDraperMulti("");

        setSaree1("")
        setSaree2("")
        setSaree3("")
        setSaree4("")
        setSaree5("")
        setSaree6("")
        setSaree7("")
        setSaree8("")
        setSaree9("")

        setSareeBack1("")
        setSareeBack2("")
        setSareeBack3("")
        setSareeBack4("")
        setSareeBack5("")

        setSareeNoModel1("")
        setSareeNoModel2("")
        setSareeNoModel3("")
        setSareeNoModel4("")
        setSareeNoModel5("")
        setSareeNoModel6("")
        setSareeNoModel7("")
        setSareeNoModel8("")
        setSareeNoModel9("")
        setSareeNoModel10("")
        setSareeNoModel11("")

        setSareeFold1("")
        setSareeFold2("")
        setSareeFold3("")
        setSareeFold4("")
        setSareeFold5("")
        setSareeFold6("")
        setSareeFold7("")
        setSareeFold8("")

        setSareeSide1("")
        setSareeSide2("")
        setSareeSide3("")
        setSareeSide4("")
        setSareeSide5("")
        setSareeSide6("")
        setSareeSide7("")
        setSareeSide8("")
        setSareeSide9("")

        setIsDraped(false)

    }

    const DownloadZip = (ImageFront, ImageBack, ImageNoModel, ImageFold, ImageSide) => {
        setIsLoadingMini(true)
        var zip = new JSZip();
        zip.file("ImageFront.png", ImageFront.replace("data:image/png;base64,", ""), { base64: true });
        zip.file("ImageBack.png", ImageBack.replace("data:image/png;base64,", ""), { base64: true });
        zip.file("ImageNoModel.png", ImageNoModel.replace("data:image/png;base64,", ""), { base64: true });
        zip.file("ImageFold.png", ImageFold.replace("data:image/png;base64,", ""), { base64: true });
        zip.file("ImageSide.png", ImageSide.replace("data:image/png;base64,", ""), { base64: true });

        zip.generateAsync({ type: "blob" }).then(content => {
            // see FileSaver.js
            saveAs(content, "Baithka Draper.zip");
            setIsLoadingMini(false)
        }).catch(error => {
            setIsLoadingMini(false)
            alert(error)
        });
    }

    const printRef = useRef();
    return (
        <Container title="Drap Saree" isBack={true}>
            {isDraped ?
                ""
                :
                <>
                    <DrapingBalance />
                    <form onSubmit={formik.handleSubmit} class="form-horizontal">
                        <div className="row">

                            <div className="col-md-4">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right"><b className='red'>*</b>Item Name</label>
                                        <TextBoxTranslater className="form-control" type="text" placeholder="Item Name" name="itemName" value={formik.values.itemName} onChange={(e) => formik.setValues({ ...formik.values, itemName: e.target.value })} />
                                        {
                                            formik.touched.itemName &&
                                                formik.errors.itemName ? (
                                                <label className="text-danger" >
                                                    {formik.errors.itemName}
                                                </label>
                                            ) : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right"><b className='red'>*</b>Item Code</label>
                                        <TextBoxTranslater className="form-control" type="text" placeholder="Item Code" name="itemCode" value={formik.values.itemCode} onChange={(e) => formik.setValues({ ...formik.values, itemCode: e.target.value })} />
                                        {
                                            formik.touched.itemCode &&
                                                formik.errors.itemCode ? (
                                                <label className="text-danger" >
                                                    {formik.errors.itemCode}
                                                </label>
                                            ) : null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right">Description</label>
                                        <TextBoxTranslater className="form-control" type="text" placeholder="Description" name="note" value={formik.values.note} onChange={(e) => formik.setValues({ ...formik.values, note: e.target.value })} />
                                        {
                                            formik.touched.note &&
                                                formik.errors.note ? (
                                                <label className="text-danger" >
                                                    {formik.errors.note}
                                                </label>
                                            ) : null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right"><b className='red'>*</b>Saree Photo 1</label>
                                        <FileUploader setFile={setImg1} isBase64={true} width={1200} height={700} />
                                        <span>
                                            for perfect result resolution should width:1200px | height:700px
                                        </span>
                                        <span>
                                            <Zoom>
                                                <img style={{ height: "200px" }} src={img1 ? img1 : "./assets/images/Draper/1.jpeg"} className="img-responsive" />
                                            </Zoom>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right"><b className='red'>*</b>Saree Photo 2 (Saree Pallu)</label>
                                        <FileUploader setFile={setImg2} isBase64={true} width={700} height={1200} />
                                        <span>
                                            for perfect result resolution should width:700px | height:1200px
                                        </span>
                                        <Zoom>
                                            <img style={{ height: "200px" }} src={img2 ? img2 : "./assets/images/Draper/2.jpeg"} className="img-responsive" />
                                        </Zoom>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right"><b className='red'>*</b>Saree Photo 3 (Saree Blouse)</label>
                                        <FileUploader setFile={setImg3} isBase64={true} width={600} height={600} />
                                        <span>
                                            for perfect result resolution should width:600px | height:600px
                                        </span>
                                        <Zoom>
                                            <img style={{ height: "200px" }} src={img3 ? img3 : "./assets/images/Draper/3.jpg"} className="img-responsive" />
                                        </Zoom>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right">Set Photo</label>
                                        <FileUploader setFile={setImg4} isBase64={true} width={300} height={600} />
                                        <span>
                                            for perfect result resolution should width:300px | height:600px
                                        </span>
                                        <span>
                                            <Zoom>
                                                <img style={{ height: "200px", display: "revert" }} src={img4 ? img4 : "./assets/images/Draper/4.png"} className="img-responsive" />
                                                <img style={{ height: "200px", display: "revert" }} src={"./assets/images/Draper/4b.png"} className="img-responsive" />
                                            </Zoom>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right">Is Light Color</label>
                                        <div>
                                            <input onChange={() => formik.setValues({ ...formik.values, isLight: (formik.values.isLight == 1 ? 0 : 1), isReal: (formik.values.isLight == 1 ? 0 : 0) })} checked={formik.values.isLight == 1} type="checkbox" class="ace ace-switch ace-switch-5" />
                                            <span class="lbl middle"></span>
                                        </div>
                                        <small>Note: Selecting yes will improve light color sarees quality.</small>
                                        {
                                            formik.touched.isLight &&
                                                formik.errors.isLight ? (
                                                <label className="text-danger" >
                                                    {formik.errors.isLight}
                                                </label>
                                            ) : null
                                        }

                                    </div>
                                </div>

                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right">Is Real Colors</label>
                                        <div>
                                            <input onChange={() => formik.setValues({ ...formik.values, isReal: (formik.values.isReal == 1 ? 0 : 1), isLight: (formik.values.isReal == 1 ? 0 : 0) })} checked={formik.values.isReal == 1} type="checkbox" class="ace ace-switch ace-switch-5" />
                                            <span class="lbl middle"></span>
                                        </div>
                                        <small>Note: Selecting yes will improve color quality of the saree but it may reduse draping quality (don't use in black color sarees).</small>
                                        {
                                            formik.touched.isReal &&
                                                formik.errors.isReal ? (
                                                <label className="text-danger" >
                                                    {formik.errors.isReal}
                                                </label>
                                            ) : null
                                        }

                                    </div>
                                </div>

                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right">With Lace</label>
                                        <div>
                                            <input onChange={() => formik.setValues({ ...formik.values, isLace: (formik.values.isLace == 1 ? 0 : 1) })} checked={formik.values.isLace == 1} type="checkbox" class="ace ace-switch ace-switch-5" />
                                            <span class="lbl middle"></span>
                                        </div>
                                        <small>Note: Selecting yes will attach lace on the bottom of the saree.</small>
                                        {
                                            formik.touched.isLace &&
                                                formik.errors.isLace ? (
                                                <label className="text-danger" >
                                                    {formik.errors.isLace}
                                                </label>
                                            ) : null
                                        }

                                    </div>
                                </div>

                            </div>
                            <div className="col-md-3">
                                <div class="form-group">
                                    <div class="col-xs-12">
                                        <label class="control-label no-padding-right">Blur Model Face</label>
                                        <div>
                                            <input onChange={() => formik.setValues({ ...formik.values, isModelBlur: (formik.values.isModelBlur == 1 ? 0 : 1) })} checked={formik.values.isModelBlur == 1} type="checkbox" class="ace ace-switch ace-switch-5" />
                                            <span class="lbl middle"></span>
                                        </div>
                                        <small>Note: Selecting yes will blur (hide) the face of model.</small>
                                        {
                                            formik.touched.isModelBlur &&
                                                formik.errors.isModelBlur ? (
                                                <label className="text-danger" >
                                                    {formik.errors.isModelBlur}
                                                </label>
                                            ) : null
                                        }

                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="clearfix form-actions">
                            <div class="pull-right">
                                {localLoading ?
                                    <button class="btn btn-info" expand="block" disabled>
                                        <i class="ace-icon fa fa-check bigger-110"></i>
                                        Processing...
                                    </button>

                                    :
                                    <>
                                        <button class="btn btn-info" disabled={localLoading || !formik.isValid || !img1 || !img2 || !img3 || !saree1 || !saree2 || !saree3 || !saree4 || !saree5
                                            || !saree6 || !saree7 || !saree8 || !saree9 || !sareeBack1 || !sareeBack2 || !sareeBack3 || !sareeBack4 || !sareeBack5 ||
                                            !sareeNoMOdel1 || !sareeNoMOdel2 || !sareeNoMOdel3 || !sareeNoMOdel4 || !sareeNoMOdel5 || !sareeNoMOdel6 || !sareeNoMOdel7 || !sareeNoMOdel8 ||
                                            !sareeNoMOdel9 || !sareeNoMOdel10 || !sareeNoMOdel11 || !GetsareeFold1 || !GetsareeFold2 || !GetsareeFold3 || !GetsareeFold4 ||
                                            !GetsareeFold5 || !GetsareeFold6 || !GetsareeFold7 || !GetsareeFold8 || !GetsareeSide1 || !GetsareeSide2 || !GetsareeSide3 ||
                                            !GetsareeSide4 || !GetsareeSide5 || !GetsareeSide6 || !GetsareeSide7 || !GetsareeSide8 || !GetsareeSide9}>
                                            <i class="ace-icon fa fa-check bigger-110"></i>
                                            Drap Now
                                        </button>
                                    </>
                                }
                            </div>
                        </div>

                    </form>
                </>
            }

            {!localLoading && isSaved ?
                <>
                    {FinalDraper && FinalDraperMulti ?
                        <div className="row">
                            {getIsPrint && <div style={{ display: "none" }}>
                                <DrapingPrint FinalDraper={FinalDraper} FinalDraperBack={FinalDraperMulti} itemName={formik.values.itemName} itemCode={formik.values.itemCode} organization={organization} ref={printRef} />
                            </div>}
                            <div class="btn-group">

                                <button style={{ marginRight: "10px" }} class="btn btn-xs bigger-120 btn-default" onClick={DrapReset}>
                                    <i class="ace-icon fa fa-arrow-left"></i> Reset
                                </button>
                                {(isDraped && isDrapedFrontCompleted && isDrapedBackCompleted) &&
                                    isLoadingMini ?
                                    <button style={{ marginRight: "10px" }} class="btn btn-xs bigger-120 btn-info" disabled>
                                        <i class="ace-icon fa fa-upload"></i> Uploading to server...
                                    </button>
                                    :
                                    <button style={{ marginRight: "10px" }} class="btn btn-xs bigger-120 btn-info" onClick={DrapeUpload}>
                                        <i class="ace-icon fa fa-upload"></i> Upload & Save Draping
                                    </button>
                                }

                                {isLoadingMini ?
                                    <button style={{ marginRight: "10px" }} class="btn btn-xs bigger-120 btn-success" disabled>
                                        <i class="ace-icon fa fa-download"></i> Downloading...
                                    </button>
                                    :
                                    <button style={{ marginRight: "10px" }} class="btn btn-xs bigger-120 btn-success" onClick={() => { DownloadZip(FinalDraper, FinalDraperBack, FinalDraperNoModel, FinalDraperFold, FinalDraperSide) }}>
                                        <i class="ace-icon fa fa-download"></i> Download Draping
                                    </button>
                                }

                                {getIsPrint && <PrintStarterDash printRef={printRef} />}
                            </div>

                            <hr />
                            <DrapingView FinalDraper={FinalDraper} FinalDraperBack={FinalDraperMulti} itemName={formik.values.itemName} itemCode={formik.values.itemCode} note={formik.values.note} organization={organization} />
                        </div>
                        :
                        isDraped ?
                            <div className="row center">
                                <img src='./images/loader.gif' />
                                <h3 className='center'>Processing images...</h3>
                                <br />
                            </div>
                            : ""
                    }
                </>
                :
                isDraped ?
                    <div className="row center">
                        <img src='./images/loader.gif' />
                        <h3 className='center'>Processing images...</h3>
                        <br />
                    </div>
                    : ""
            }
        </Container >
    );
}
